export const HIGH_REWARD_THRESHOLD = Object.freeze({
  BASIC: 50,
  NICE: 80,
  GREAT: 100,
  JACKPOT: 150,
});

export const HIGH_REWARD_TIER = Object.freeze({
  NONE: 'none',
  BASIC: 'basic',
  NICE: 'nice',
  GREAT: 'great',
  JACKPOT: 'jackpot',
});

export const getHighRewardTier = (rewardPoint) => {
  if (rewardPoint >= HIGH_REWARD_THRESHOLD.JACKPOT) return HIGH_REWARD_TIER.JACKPOT;
  if (rewardPoint >= HIGH_REWARD_THRESHOLD.GREAT) return HIGH_REWARD_TIER.GREAT;
  if (rewardPoint >= HIGH_REWARD_THRESHOLD.NICE) return HIGH_REWARD_TIER.NICE;
  if (rewardPoint >= HIGH_REWARD_THRESHOLD.BASIC) return HIGH_REWARD_TIER.BASIC;
  return HIGH_REWARD_TIER.NONE;
};

export const isHighRewardPoint = (rewardPoint) => rewardPoint >= HIGH_REWARD_THRESHOLD.BASIC;
